export enum ODK {
  // Home Offensive
  Offensive = 'O',
  // Home Defensive
  Defensive = 'D',
  Kick = 'K',
  Others = 'X'
}
